import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import flatten from '../utilities/flatten'
import getItemByItemKey from './getItemByItemKey'

const getKitSuggestionsByKitId = async ({ kitId }) => {
	if (!kitId) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getKitSuggestionsByKitId')
	}
	try {
		const suggestionsQuerySnap = await firestore.collection('kits').doc(kitId).collection('suggestions').get()
		const suggestions = []
		suggestionsQuerySnap.forEach((snap) => {
			suggestions.push(snap.data())
		})

		const itemTasks = flatten(
			suggestions.map(suggestion => Object.keys(suggestion.items)
				.map(async (suggestionKey) => {
					const suggestionItem = suggestion.items[suggestionKey]
					const { itemKey } = suggestionItem
					const { item } = await getItemByItemKey({ itemKey })
					suggestionItem.item = item
				}))
		)
		await Promise.all(itemTasks)

		return { suggestions }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, kitId, exception)
	}
}

export default getKitSuggestionsByKitId



// WEBPACK FOOTER //
// ./src/dataservices/getKitSuggestionsByKitId.js